import { lazyWithSuspense } from '~/utilities/lazyWithSuspense';
import { LoadingState } from './LoadingState';

export const AnonymousRecord = lazyWithSuspense(async () => import('./AnonymousRecordScreen'), {
  loadingState: <LoadingState />,
});
